import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-widget-two',
  templateUrl: './widget-two.component.html',
  styleUrls: ['./widget-two.component.sass']
})
export class WidgetTwoComponent implements OnInit {
  data = ["New Project", "New workflow", "Upload data"]

  constructor() { }

  ngOnInit(): void {
  }

  alert(i) {}

}
